import { LoadingModel } from '../loading.model';
import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { StorageService } from '../../../services/storage.service';
import { SaveUser } from './auth.actions';
import { User } from '../../../models/user';
import { patch } from '@ngxs/store/operators';

export type AuthStateModel = LoadingModel & {
  user: User | null, // This will be useless until we remove the refresh after login
};

export const initialState: AuthStateModel = {
  isLoading: false,
  user: null,
};

@State<AuthStateModel>({
  name: 'auth',
  defaults: initialState,
})
@Injectable()
export class AuthState {
  private readonly storageService = inject(StorageService);

  @Action(SaveUser)
  saveUser(context: StateContext<AuthStateModel>, { user }: SaveUser) {
    this.storageService.set('session', user.session);
    this.storageService.set('user', JSON.stringify(user));

    // This will be useless until we remove the refresh after login
    context.setState(
      patch({ user }),
    );
  }
}
